import { ProfileService } from './../../services/profile.services';
import { AuthGuard } from './auth-guard.service';
import { AppConfiguration } from '../conf/app.configuration';
import { AuthService } from '../auth.service';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '../../../node_modules/@angular/router';
import { Store } from '../../../node_modules/@ngrx/store';
import { AppState } from '../store/AppState';
import { UserService } from '../user.service';
import { map, tap } from 'rxjs/operators';
import { ServiceLocator } from '../ServiceLocator';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable()
export class ProfileGuard extends AuthGuard {


  private profileService: ProfileService;

  constructor(
    private userService: UserService,
    appConfig: AppConfiguration,
    auth: AuthService,
    router: Router,
    store: Store<AppState>
  ) {
    super(appConfig, auth, router, store);
    this.profileService = ServiceLocator.injector.get(ProfileService);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return super.canActivate(route, state).pipe(
      map(
        can => {
          if (can) {

            // perfiles de acceso a la ruta
            let roles = route.data['roles'] as string;

            // Si no tiene perfiles deifnidos, revisamos si es una opción del panel de control
            if (roles == undefined || roles == '') {
              let controlPanelOption = this.profileService.getControlPanelMenuOption(route);
              if (controlPanelOption != undefined) {  // Acceso al panel de control
                // Si se accede a las acciones
                if (controlPanelOption.linkTo === '/actions') {
                  // si es una acción categorizada y el actions general
                  if (route.params != undefined && route.params != {} && route.params.actionClasification != undefined
                    && route.params.actionClasification != '') {
                    controlPanelOption = this.profileService.getControlPanelActionMenuOption(route.params.actionClasification);
                  }
                  can = controlPanelOption.profiles === undefined
                    || controlPanelOption.profiles === ''
                    || this.userService.hasRoles(controlPanelOption.profiles);
                } else { // Si se accede a un opción del panel de control que no es una acción
                  can = controlPanelOption.profiles === undefined
                    || controlPanelOption.profiles === ''
                    || this.userService.hasRoles(controlPanelOption.profiles);
                }


              } else if ('dossierCreation') {
                // Acceso a preparar ¿¿ Problemas en el acceso a CIXTE en el basic info¿?¿?¿?
                if (route.params != undefined && route.params != {} && route.params.id != undefined
                  && route.params.id != '') {
                  can = this.profileService.isHasPrepareProjectRoles();
                }
                /*
                else if (route.params != undefined && route.params != {} && route.params.id != undefined
                  && route.params.model === true) {
                  can = this.userService.hasRoles('1,50');
                }
            */
              } else {
                // No se hace nada por que no hay perfiles definidos para esta ruta.
              }
            } else { // Si tiene perfiles definidos la ruta, se comprueba si los tiene el usuario
              can = this.userService.hasRoles(roles);
            }

          }


          if (!can) {
            console.error('No dispone de perfil para acceder a la ruta', route);
            this.router.navigate(['accesoDenegado']);
          }

          return can;


        }
      )
    );



  }
}
